import { API_V2_URL } from '../../config/urls';
import useRequest from './request-v2';

export default function useAuthHttpService() {
    const { get, post } = useRequest({ baseURL: API_V2_URL });

    const uri = 'auth';

    const getUser = async () => {
        return get(`${uri}/user`);
    };

    const logout = async () => {
        return post(`${uri}/logout`);
    };

    return {
        getUser,
        logout,
    };
}
